import { Component } from '@angular/core';


export class SkyLabelDemoComponent { static decorators: DecoratorInvocation[] = [
{ type: Component, args: [{
  selector: 'sky-label-demo',
  template: `<sky-label labelType="info">
  Info label
</sky-label>
<sky-label labelType="success">
  Success label
</sky-label>
<sky-label labelType="warning">
  Warning label
</sky-label>
<sky-label labelType="danger">
  Danger label
</sky-label>
`
}, ] },
];
/** @nocollapse */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
];
}

interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
